import { render } from "./OtherCharges.vue?vue&type=template&id=2094013a&scoped=true"
import script from "./OtherCharges.vue?vue&type=script&lang=js"
export * from "./OtherCharges.vue?vue&type=script&lang=js"

import "./OtherCharges.vue?vue&type=style&index=0&id=2094013a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2094013a"]])

export default __exports__